export default __webpack_public_path__ + "static/media/icon.58d138fd.png";